import { Field, Image, ImageField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';

import styles from './HandbookIndex.module.css';

type ResourceIndexProps = ComponentProps & {
	fields: {
		Pages: [
			ExtendedItem & {
				fields: {
					PageTitle: Field<string>;
					PageIcon: ImageField;
					NavigationLinkText: Field<string>;
				};
			}
		];
		ContentListText: Field<string>;
	};
};

export default withDatasourceCheck()<ResourceIndexProps>(HandbookIndex);

function HandbookIndex(props: ResourceIndexProps): JSX.Element {
	return (
		<section className={styles.resourceIndex}>
			<Text className={styles.title} tag="h2" field={props.fields.ContentListText} />
			<ul className={styles.list}>
				{props.fields.Pages.map((page, index) => {
					return (
						<li className={styles.listItem} key={index}>
							<a className={styles.link} title={page.fields.PageTitle?.value} href={page.path}>
								<Image
									className={styles.icon}
									field={page.fields.PageIcon}
									alt={page.fields.PageTitle}
									loading="lazy"
									height={200}
									width={300}
								/>
								<Text className={styles.linkText} tag="span" field={page.fields.NavigationLinkText} />
							</a>
						</li>
					);
				})}
			</ul>
		</section>
	);
}
